<template>
    <div>
        <base-button type="primary" size="sm" v-on:click="showModal = true" icon="ni ni-fat-add"></base-button>
        <form @submit.prevent="addAction">
        <modal :show="showModal">
        <template v-slot:header>
            <h5 class="modal-title" id="exampleModalLabel">Neue Maßnahme anlegen</h5>
        </template>
        <div>

                <div class="pl-lg-4">
                    <div class="row">
                        <div class="col-lg-6">
                            <base-input alternative=""
                                        required
                                        label="Interne Bezeichnung"
                                        input-classes="form-control-alternative"
                                        v-model="action.name"
                            />
                        </div>
                        <div class="col-lg-6">
                            <base-input alternative=""
                                        required
                                        label="Öffentliche Bezeichnung"
                                        input-classes="form-control-alternative"
                                        v-model="action.publicName"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <base-input alternative=""
                                        required
                                        label="Kategorie"
                                        input-classes="form-control-alternative"
                                        v-model="action.category"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <label class="form-control-label">
                                Öffentlich
                                <span>*</span></label>
                            <switches v-model="action.isPublic"
                                      theme="bootstrap"
                                      color="primary"
                                      style="padding-left: 2rem;"
                                      text-enabled="öffentlich"
                                      text-disabled="intern"></switches>
                        </div>
                        <div class="col-lg-6">
                            <label class="form-control-label">
                                Art
                                <span>*</span></label>
                            <switches v-model="action.isSetAuto"
                                      theme="bootstrap"
                                      color="primary"
                                      style="padding-left: 2rem;"
                                      text-enabled="automatisch"
                                      text-disabled="manuell"></switches>
                        </div>
                    </div>
                </div>

        </div>
        <template v-slot:footer>
            <base-button type="secondary" @click="showModal = false">Close</base-button>
            <button class="btn btn-icon my-4 btn-primary" :disabled="isLoading">
                <span class="btn-inner--icon"><i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i><i v-else class="ni ni-fat-add"></i></span>
                <span class="btn-inner--text">Maßnahme anlegen</span></button>
        </template>
    </modal>
        </form>
   </div>
</template>

<script>
    import Switches from "vue-switches";
    export default {
        name: "createAction",
        components:{Switches},
        props:{
            socialconcept:{
                type: String
            },
        },
        data() {
            return {
                action: {
                    name: "",
                    publicName: "",
                    category: '',
                    isSetAuto: false,
                    isPublic: false,
                    socialconcept: null },
                isLoading: false,
                showModal: false,
            }
        },
        computed: {
        },
        methods: {
            addAction() {
                this.isLoading = true;
                this.createAction()
                    .then(response => {
                        this.isLoading = false;
                        this.$store.dispatch('alert/success','Maßnahme "'+response.name+'" (ID: '+response.id+') angelegt.');
                        this.showModal = false;
                        this.$emit('actionCreated')
                    })
                    .catch(error => {
                    this.isLoading = false;
                    this.$store.dispatch('alert/error',error)
                    });
            },
            createAction() {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    let senddata = this.action;
                    senddata.socialconcept = this.socialconcept;
                    const requestOptions = {
                        method: 'POST',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    fetch(process.env.VUE_APP_API_SERVER + `/api/actions`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve(response);
                            },
                            error => {
                                reject(error);
                            });
                });
            }
        }
    }
</script>

